export default __webpack_public_path__ + "static/media/logo.82130689.svg";